import { IMaintenanceEvent } from '@/pages/Calendar/calendar.types'
import MaintenanceEventTypeLabel from '../MaintenanceEventTypeLabel/MaintenanceEventTypeLabel'
import css from './eventCell.module.css'
import { IEquipmentLocation } from '@/pages/Equipment/equipment.types'
import equipmentUtils from '@/pages/Equipment/equipment.utils'

interface IProps {
  event: IMaintenanceEvent
  equipmentLocation: IEquipmentLocation
  onClick: () => void
}

const EventCell = (props: IProps) => {
  const renderNoResponsibleLabel = () => {
    if (props.event.metadata.responsibleUsers.length === 0 && props.event.type === 'OVERDUE_MAINTENANCE') {
      return <MaintenanceEventTypeLabel eventType={'NO_RESPONSIBLE'} />
    }
    return null
  }

  return (
    <div className={css.wrapper} onClick={props.onClick}>
      <div className="flex-lines gap4" style={{ alignItems: 'start' }}>
        <MaintenanceEventTypeLabel eventType={props.event.type} />
        {renderNoResponsibleLabel()}
      </div>
      <div
        className="text-nm"
        style={{ textDecoration: props.event.type === 'COMPLETED_MAINTENANCE' ? 'line-through' : 'none' }}
      >
        {equipmentUtils.getEquipmentAddress(props.equipmentLocation) || 'Адрес не указан'}
      </div>
    </div>
  )
}

export default EventCell
